import { useToast } from "@hooks"
import { useCallback, useEffect } from "react"
import { postSubmit } from "@ui-seeker/utils"
import { BACKEND_APIS } from "@constants"
import { formData, tableData } from "Pages/BusinessLogistics/LeadingAnalyzer/Page/@signals"
import { GROUPING_METHOD } from "Pages/BusinessLogistics/LeadingAnalyzer/Page/@constants"
import { isLoadingCommonFilters } from "@signals"
import { batch } from "@preact/signals-react"

export default function useLeadingAnalyzerFilters() {

	const { showToast } = useToast()

	const handleSubmit = useCallback(() => {
		isLoadingCommonFilters.value = true
		postSubmit(`${BACKEND_APIS.DASHBOARD}/results`, formData.value)
			.then(({ tableDataMin, tableDataMax, tableDataAvg, xlist, filters, no_results }) => batch(() => {
				tableData.value = {
					min: tableDataMin,
					max: tableDataMax,
					avg: tableDataAvg,
					xList: xlist,
					isDaily: filters.groupBy === GROUPING_METHOD.DAILY,
					noResults: no_results,
					empty: false,
				}
				isLoadingCommonFilters.value = false
			}))
			.catch(() => {
				showToast.error('Error submitting filters!')
				isLoadingCommonFilters.value = false
			})
	}, [])

	useEffect(() => {
		if (isLoadingCommonFilters.value) handleSubmit()
	}, [isLoadingCommonFilters.value])

}